"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagStyles = exports.inputStyles = void 0;
const inputStyles = ({ typography }) => ({
    container: {
        width: '100%',
    },
    inputRoot: {
        cursor: 'pointer',
        overflow: 'hidden',
    },
    input: {
        textOverflow: 'ellipsis',
        fontSize: typography.fontSize,
        textAlign: 'center',
    },
    hiddenSpan: {
        position: 'absolute',
        left: '100%',
        fontSize: typography.fontSize,
    },
});
exports.inputStyles = inputStyles;
const tagStyles = ({ spacing, palette }) => ({
    QTag: {
        overflow: 'hidden',
    },
    chipRoot: {
        position: 'relative',
        backgroundColor: palette.background.elevated,
        '&:hover': {
            backgroundColor: palette.background.subtle,
        },
        '&:hover input': {
            maxWidth: '90%',
            marginRight: '20%',
            cursor: 'pointer',
        },
        '& > svg': {
            position: 'absolute',
            display: 'none',
            width: spacing(3),
            height: spacing(3),
            right: 0,
        },
        '&:hover > svg': {
            display: 'block',
        },
    },
    chipOutlined: {
        borderColor: palette.text.primary,
        backgroundColor: 'inherit !important',
        '&:focus': {
            backgroundColor: 'inherit !important',
        },
    },
    outlinedIcon: {
        borderRadius: '50%',
        backgroundColor: palette.secondary.main,
        color: `${palette.secondary.contrastText} !important`,
        width: spacing(2.5),
        height: spacing(2.5),
        padding: 1,
        '&:hover': {
            backgroundColor: palette.secondary.dark,
        },
    },
    disabledAddBtn: {
        backgroundColor: palette.action.disabled,
        cursor: 'default',
        '&:hover': {
            backgroundColor: palette.action.disabled,
        },
    },
});
exports.tagStyles = tagStyles;
